'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var common = require('@andes/common');
var includes = require('@andes/common/build/utils/includes');
var warning = require('@andes/common/build/utils/warning');
var currencies = require('@andes/common/build/constants/currencies');
var computeMaxDecimals = require('@andes/common/build/utils/computeMaxDecimals');
var computeDecimalRounding = require('@andes/common/build/utils/computeDecimalRounding');
var removeNonNumericCharacters = require('@andes/common/build/utils/removeNonNumericCharacters');
var BTCIcon = require('@andes/icons/BTC48');
var ETHIcon = require('@andes/icons/ETH20');
var USDPIcon = require('@andes/icons/USDP20');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var computeMaxDecimals__default = /*#__PURE__*/_interopDefaultLegacy(computeMaxDecimals);
var computeDecimalRounding__default = /*#__PURE__*/_interopDefaultLegacy(computeDecimalRounding);
var removeNonNumericCharacters__default = /*#__PURE__*/_interopDefaultLegacy(removeNonNumericCharacters);
var BTCIcon__default = /*#__PURE__*/_interopDefaultLegacy(BTCIcon);
var ETHIcon__default = /*#__PURE__*/_interopDefaultLegacy(ETHIcon);
var USDPIcon__default = /*#__PURE__*/_interopDefaultLegacy(USDPIcon);
const formatAmount = _ref => {
  let {
    fraction,
    cents
  } = _ref;
  if (!fraction || typeof fraction !== 'string') return;
  const formattedFraction = fraction.replace(/[,.]/g, '');
  if (cents) {
    return "".concat(formattedFraction, ".").concat(cents);
  }
  return formattedFraction;
};
var formatAmount$1 = formatAmount;
const DEFAULT_CURRENCY_SYMBOL_TEXT = {
  singular: 'peso',
  plural: 'pesos'
};
const DEFAULT_CENTS_TEXT = {
  singular: 'centavo',
  plural: 'centavos'
};
const CURRENCY_TEXT_BY_SYMBOL = {
  $: DEFAULT_CURRENCY_SYMBOL_TEXT,
  Bs: {
    singular: 'boliviano',
    plural: 'bolivianos'
  },
  R$: {
    singular: 'real',
    plural: 'reales'
  },
  UF: {
    singular: 'unidad de fomento',
    plural: 'unidades de fomento'
  },
  '₡': {
    singular: 'colón',
    plural: 'colones'
  },
  CUC: DEFAULT_CURRENCY_SYMBOL_TEXT,
  '€': {
    singular: 'euro',
    plural: 'euros'
  },
  Q: {
    singular: 'quetzal guatemalteco',
    plural: 'quetzales guatemaltecos'
  },
  L: {
    singular: 'lempira',
    plural: 'lempiras'
  },
  C$: {
    singular: 'córdoba',
    plural: 'córdobas'
  },
  'B/.': {
    singular: 'balboa',
    plural: 'balboas'
  },
  'S/': {
    singular: 'sol',
    plural: 'soles'
  },
  '₲': {
    singular: 'guaraní',
    plural: 'guaraníes'
  },
  US$: {
    singular: 'dólar',
    plural: 'dólares'
  },
  'Bs.': {
    singular: 'bolívar',
    plural: 'bolívares'
  }
};
const CURRENCY_TEXT_BY_ID = {
  ARS: {
    singular: 'peso argentino',
    plural: 'pesos argentinos'
  },
  BOB: {
    singular: 'boliviano',
    plural: 'bolivianos'
  },
  BRL: {
    singular: 'real',
    plural: 'reales'
  },
  BTC: 'bitcoins',
  CLF: {
    singular: 'unidad de fomento',
    plural: 'unidades de fomento'
  },
  CLP: {
    singular: 'peso chileno',
    plural: 'pesos chilenos'
  },
  COP: {
    singular: 'peso colombiano',
    plural: 'pesos colombianos'
  },
  CRC: {
    singular: 'colón',
    plural: 'colones'
  },
  CUC: {
    singular: 'peso cubano convertible',
    plural: 'pesos cubanos convertibles'
  },
  CUP: {
    singular: 'peso cubano',
    plural: 'pesos cubanos'
  },
  DOP: {
    singular: 'peso dominicano',
    plural: 'pesos dominicanos'
  },
  EUR: {
    singular: 'euro',
    plural: 'euros'
  },
  ETH: 'ethereum',
  GTQ: {
    singular: 'quetzal guatemalteco',
    plural: 'quetzales guatemaltecos'
  },
  HNL: {
    singular: 'lempira',
    plural: 'lempiras'
  },
  MCN: 'mercado coin',
  MXN: {
    singular: 'peso mexicano',
    plural: 'pesos mexicanos'
  },
  NIO: {
    singular: 'córdoba',
    plural: 'córdobas'
  },
  PAB: {
    singular: 'balboa',
    plural: 'balboas'
  },
  PEN: {
    singular: 'sol',
    plural: 'soles'
  },
  PYG: {
    singular: 'guaraní',
    plural: 'guaraníes'
  },
  USD: {
    singular: 'dólar',
    plural: 'dólares'
  },
  USDP: 'USDP Stablecoin',
  UYU: {
    singular: 'peso uruguayo',
    plural: 'pesos uruguayos'
  },
  VEF: {
    singular: 'bolívar',
    plural: 'bolívares'
  },
  VES: {
    singular: 'bolívar',
    plural: 'bolívares'
  },
  DCE: {
    singular: 'dólar',
    plural: 'dólares'
  }
};
const CENTS_TEXT_BY_SYMBOL = {
  $: DEFAULT_CENTS_TEXT,
  Bs: DEFAULT_CENTS_TEXT,
  R$: DEFAULT_CENTS_TEXT,
  UF: DEFAULT_CENTS_TEXT,
  '₡': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  CUC: DEFAULT_CENTS_TEXT,
  '€': DEFAULT_CENTS_TEXT,
  Q: DEFAULT_CENTS_TEXT,
  L: DEFAULT_CENTS_TEXT,
  C$: DEFAULT_CENTS_TEXT,
  'B/.': {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  'S/': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  '₲': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  US$: DEFAULT_CENTS_TEXT,
  'Bs.': DEFAULT_CENTS_TEXT
};
const CENTS_TEXT_BY_ID = {
  ARS: DEFAULT_CENTS_TEXT,
  BOB: DEFAULT_CENTS_TEXT,
  BRL: DEFAULT_CENTS_TEXT,
  CLF: DEFAULT_CENTS_TEXT,
  CLP: DEFAULT_CENTS_TEXT,
  COP: DEFAULT_CENTS_TEXT,
  CRC: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  CUC: DEFAULT_CENTS_TEXT,
  CUP: DEFAULT_CENTS_TEXT,
  DOP: DEFAULT_CENTS_TEXT,
  EUR: DEFAULT_CENTS_TEXT,
  GTQ: DEFAULT_CENTS_TEXT,
  HNL: DEFAULT_CENTS_TEXT,
  MXN: DEFAULT_CENTS_TEXT,
  NIO: DEFAULT_CENTS_TEXT,
  PAB: {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  PEN: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  PYG: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  USD: DEFAULT_CENTS_TEXT,
  UYU: {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  VEF: DEFAULT_CENTS_TEXT,
  VES: DEFAULT_CENTS_TEXT,
  DCE: DEFAULT_CENTS_TEXT
};
const getRelatedText = (symbol, currencyId, DEFAULT, TEXT_BY_SYMBOL, TEXT_BY_ID) => {
  if (!symbol && !currencyId) return DEFAULT;
  if (!includes__default["default"](currencies.CURRENCY_SYMBOLS, symbol) && !includes__default["default"](Object.values(currencies.AVAILABLE_CURRENCIES), currencyId)) return DEFAULT;
  return TEXT_BY_SYMBOL[String(symbol)] || TEXT_BY_ID[String(currencyId)] || DEFAULT;
};
const getCurrencyText = (symbol, currencyId) => getRelatedText(symbol, currencyId, DEFAULT_CURRENCY_SYMBOL_TEXT, CURRENCY_TEXT_BY_SYMBOL, CURRENCY_TEXT_BY_ID);
const getCentsText = (symbol, currencyId) => getRelatedText(symbol, currencyId, DEFAULT_CENTS_TEXT, CENTS_TEXT_BY_SYMBOL, CENTS_TEXT_BY_ID);
const getAccesibleAmount = (i18n, combo, previous, _ref) => {
  let {
    symbol,
    currencyId,
    fraction,
    cents
  } = _ref;
  if (!i18n || !currencyId && !symbol || !fraction) return '';
  const context = 'andes-money-amount';
  const currencyText = getCurrencyText(symbol, currencyId);
  const centsText = getCentsText(symbol, currencyId);
  const normalizedFraction = fraction.replace(/[,.]/g, '');
  let amountText = '';
  if (combo) {
    amountText += i18n.pgettext(context, previous ? 'Antes: ' : 'Ahora: ');
  } else if (previous) {
    amountText += i18n.pgettext(context, 'Antes: ');
  }
  amountText += i18n.npgettext(context, "{0} ".concat(currencyText.singular), "{0} ".concat(currencyText.plural), Number(normalizedFraction), normalizedFraction);
  if (cents && Number(cents)) {
    amountText += i18n.npgettext(context, " con {0} ".concat(centsText.singular), " con {0} ".concat(centsText.plural), Number(cents), cents);
  }
  return amountText;
};
const getCryptoAccesibleAmount = (_ref2, centsType) => {
  let {
    currencyId,
    fraction,
    cents
  } = _ref2;
  if (!currencyId || !fraction) return '';
  const currencyText = getCurrencyText(undefined, currencyId);
  const normalizedFraction = fraction.replace(/[,.-]/g, '');
  const centsAmount = cents ? "".concat(centsType === 'dot' ? '.' : ',').concat(cents) : '';
  return "".concat(normalizedFraction).concat(centsAmount, " ").concat(currencyText);
};
const isNegative = fraction => fraction && typeof fraction === 'string' && fraction.startsWith('-');
var isNegative$1 = isNegative;
const getDecimalPart = value => {
  const numStr = value.toString();
  const decimalIndex = numStr.indexOf('.');
  return decimalIndex !== -1 ? numStr.slice(decimalIndex + 1) : '';
};
var getDecimalPart$1 = getDecimalPart;
const getIntegerPart = value => {
  const numStr = value.toString();
  const decimalIndex = numStr.indexOf('.');
  return decimalIndex !== -1 ? numStr.slice(0, decimalIndex) : numStr;
};
const formatWithSymbol = (integerPart, symbol) => {
  let formatted = '';
  const {
    length
  } = integerPart;
  for (let i = 0; i < length; i += 1) {
    if (i > 0 && (length - i) % 3 === 0) {
      formatted += symbol;
    }
    formatted += integerPart[i];
  }
  return formatted;
};
const getFractionPart = (value, symbol) => {
  const integerPart = getIntegerPart(value);
  return formatWithSymbol(integerPart, symbol);
};
var getFractionPart$1 = getFractionPart;
const computeAmount = _ref => {
  let {
    amount,
    value,
    currencyId,
    symbol,
    maxDecimals,
    applyHideDecimals
  } = _ref;
  const computedAmountValues = {
    currencyId: currencyId || (amount === null || amount === void 0 ? void 0 : amount.currencyId),
    symbol: symbol || (amount === null || amount === void 0 ? void 0 : amount.symbol),
    fraction: (value === null || value === void 0 ? void 0 : value.fraction) || (amount === null || amount === void 0 ? void 0 : amount.fraction),
    cents: (value === null || value === void 0 ? void 0 : value.cents) || (amount === null || amount === void 0 ? void 0 : amount.cents)
  };
  if (applyHideDecimals && computedAmountValues.fraction && computedAmountValues.cents) {
    const numberOfDecimals = computeMaxDecimals__default["default"](maxDecimals, currencyId);
    const decimalRounding = computeDecimalRounding__default["default"](Number("".concat(removeNonNumericCharacters__default["default"](computedAmountValues.fraction), ".").concat(removeNonNumericCharacters__default["default"](computedAmountValues.cents))), numberOfDecimals);
    computedAmountValues.cents = getDecimalPart$1(decimalRounding);
    computedAmountValues.fraction = getFractionPart$1(decimalRounding, '.');
    return computedAmountValues;
  }
  return computedAmountValues;
};
var computeAmount$1 = computeAmount;
const getCurrencySymbolAndText = (symbol, currencyId, isCrypto, showCurrencyText, showCurrencySymbol) => {
  if (isCrypto) return currencyId || currencies.DEFAULT_CURRENCY_SYMBOL;
  const currencySymbol = symbol || currencies.CURRENCY_SYMBOLS_BY_ID[String(currencyId)] || currencies.DEFAULT_CURRENCY_SYMBOL;
  if (showCurrencyText) {
    const currencyText = currencyId || '';
    if (showCurrencySymbol) {
      return "".concat(currencyText, " ").concat(currencySymbol).trim();
    }
    return currencyText;
  }
  return currencySymbol;
};
var getCurrencySymbolAndText$1 = getCurrencySymbolAndText;
const WARNING_CURRENCYID_OR_SYMBOL = "<MoneyAmount> needs either a defined currencyId or symbol prop to work correctly.\nPlease add a 'currencyId' or 'symbol' prop.";
const DECIMAL_SEPARATOR_COMMA = ',';
const DECIMAL_SEPARATOR_DOT = '.';
const DECIMAL_SEPARATOR_BY_CENTS_TYPE = {
  comma: DECIMAL_SEPARATOR_COMMA,
  dot: DECIMAL_SEPARATOR_DOT
};
const CENTS_SUPERSCRIPT_MARGINS = {
  12: 2,
  14: 2,
  16: 2,
  18: 3,
  20: 4,
  24: 4,
  28: 6,
  32: 7,
  36: 7,
  40: 7,
  44: 9,
  48: 9,
  52: 10,
  56: 10,
  60: 11
};
const CENTS_SUPERSCRIPT_COMPACT_MARGINS = {
  12: 1,
  14: 1,
  16: 1,
  18: 2,
  20: 3,
  24: 3,
  28: 3,
  32: 4,
  36: 4,
  40: 4,
  44: 4,
  48: 5,
  52: 5,
  56: 5,
  60: 7
};
const CENTS_SUPERSCRIPT_FONT_SIZES = {
  12: 8,
  14: 8,
  16: 10,
  18: 10
};
const COMBO_SIZES = {
  previousValue: {
    24: 12,
    36: 16
  },
  currentValue: {
    24: 24,
    36: 36
  },
  discount: {
    24: 14,
    36: 18
  }
};
var module$3 = "@andes/money-amount";
var locale$2 = "en-US";
var translations$2 = {
  "andes-money-amount\u0004Antes: ": [null, "Before: "],
  "andes-money-amount\u0004Ahora: ": [null, "Now: "],
  "andes-money-amount\u0004Monto": [null, "Amount"],
  "andes-money-amount\u0004{0} peso": [null, "{0} peso", "{0} pesos"],
  "andes-money-amount\u0004{0} peso argentino": [null, "{0} argentine peso", "{0} argentine pesos"],
  "andes-money-amount\u0004{0} peso chileno": [null, "{0} chilean peso", "{0} chilean pesos"],
  "andes-money-amount\u0004{0} peso colombiano": [null, "{0} colombian peso", "{0} colombian pesos"],
  "andes-money-amount\u0004{0} peso cubano convertible": [null, "{0} cuban convertible peso", "{0} cuban convertible pesos"],
  "andes-money-amount\u0004{0} peso cubano": [null, "{0} cuban peso", "{0} cuban pesos"],
  "andes-money-amount\u0004{0} peso dominicano": [null, "{0} dominican peso", "{0} dominican pesos"],
  "andes-money-amount\u0004{0} peso mexicano": [null, "{0} mexican peso", "{0} mexican pesos"],
  "andes-money-amount\u0004{0} peso uruguayo": [null, "{0} uruguayan peso", "{0} uruguayan pesos"],
  "andes-money-amount\u0004{0} boliviano": [null, "{0} boliviano", "{0} bolivianos"],
  "andes-money-amount\u0004{0} real": [null, "{0} reais", "{0} reais"],
  "andes-money-amount\u0004{0} unidad de fomento": [null, "{0} unidad de fomento", "{0} unidades de fomento"],
  "andes-money-amount\u0004{0} colón": [null, "{0} colón", "{0} colones"],
  "andes-money-amount\u0004{0} euro": [null, "{0} euro", "{0} euros"],
  "andes-money-amount\u0004{0} quetzal guatemalteco": [null, "{0} guatemalan quetzal", "{0} guatemalan quetzals"],
  "andes-money-amount\u0004{0} lempira": [null, "{0} honduran lempira", "{0} honduran lempiras"],
  "andes-money-amount\u0004{0} córdoba": [null, "{0} córdoba", "{0} córdobas"],
  "andes-money-amount\u0004{0} balboa": [null, "{0} balboa", "{0} balboas"],
  "andes-money-amount\u0004{0} sol": [null, "{0} peruvian sol", "{0} peruvian soles"],
  "andes-money-amount\u0004{0} guaraní": [null, "{0} guaraní", "{0} guaranís"],
  "andes-money-amount\u0004{0} dólar": [null, "{0} dollar", "{0} dollars"],
  "andes-money-amount\u0004{0} bolívar": [null, "{0} bolívar", "{0} bolívares"],
  "andes-money-amount\u0004 con {0} centavo": [null, " with {0} cent", " with {0} cents"],
  "andes-money-amount\u0004 con {0} céntimo": [null, " with {0} centimo", " with {0} centimos"],
  "andes-money-amount\u0004 con {0} centésimo": [null, " with {0} centesimo", " with {0} centesimos"],
  "andes-money-amount\u0004 por {0}": [null, "for {0}"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/money-amount";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-money-amount\u0004Antes: ": [null, "Antes: "],
  "andes-money-amount\u0004Ahora: ": [null, "Ahora: "],
  "andes-money-amount\u0004Monto": [null, "Monto"],
  "andes-money-amount\u0004{0} peso": [null, "{0} peso", "{0} pesos"],
  "andes-money-amount\u0004{0} peso argentino": [null, "{0} peso argentino", "{0} pesos argentinos"],
  "andes-money-amount\u0004{0} peso chileno": [null, "{0} peso chileno", "{0} pesos chilenos"],
  "andes-money-amount\u0004{0} peso colombiano": [null, "{0} peso colombiano", "{0} pesos colombianos"],
  "andes-money-amount\u0004{0} peso cubano convertible": [null, "{0} peso cubano convertible", "{0} pesos cubanos convertibles"],
  "andes-money-amount\u0004{0} peso cubano": [null, "{0} peso cubano", "{0} pesos cubanos"],
  "andes-money-amount\u0004{0} peso dominicano": [null, "{0} peso dominicano", "{0} pesos dominicanos"],
  "andes-money-amount\u0004{0} peso mexicano": [null, "{0} peso mexicano", "{0} pesos mexicanos"],
  "andes-money-amount\u0004{0} peso uruguayo": [null, "{0} peso uruguayo", "{0} pesos uruguayos"],
  "andes-money-amount\u0004{0} boliviano": [null, "{0} boliviano", "{0} bolivianos"],
  "andes-money-amount\u0004{0} real": [null, "{0} real", "{0} reales"],
  "andes-money-amount\u0004{0} unidad de fomento": [null, "{0} unidad de fomento", "{0} unidades de fomento"],
  "andes-money-amount\u0004{0} colón": [null, "{0} colón", "{0} colones"],
  "andes-money-amount\u0004{0} euro": [null, "{0} euro", "{0} euros"],
  "andes-money-amount\u0004{0} quetzal guatemalteco": [null, "{0} quetzal guatemalteco", "{0} quetzales guatemaltecos"],
  "andes-money-amount\u0004{0} lempira": [null, "{0} lempira", "{0} lempiras"],
  "andes-money-amount\u0004{0} córdoba": [null, "{0} córdoba", "{0} córdobas"],
  "andes-money-amount\u0004{0} balboa": [null, "{0} balboa", "{0} balboas"],
  "andes-money-amount\u0004{0} sol": [null, "{0} sol", "{0} soles"],
  "andes-money-amount\u0004{0} guaraní": [null, "{0} guaraní", "{0} guaraníes"],
  "andes-money-amount\u0004{0} dólar": [null, "{0} dólar", "{0} dólares"],
  "andes-money-amount\u0004{0} bolívar": [null, "{0} bolívar", "{0} bolívares"],
  "andes-money-amount\u0004 con {0} centavo": [null, " con {0} centavo", " con {0} centavos"],
  "andes-money-amount\u0004 con {0} céntimo": [null, " con {0} céntimo", " con {0} céntimos"],
  "andes-money-amount\u0004 con {0} centésimo": [null, " con {0} centésimo", " con {0} centésimos"],
  "andes-money-amount\u0004 por {0}": [null, "por {0}"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/money-amount";
var locale = "pt-BR";
var translations = {
  "andes-money-amount\u0004Antes: ": [null, "Antes: "],
  "andes-money-amount\u0004Ahora: ": [null, "Agora: "],
  "andes-money-amount\u0004Monto": [null, "Valor"],
  "andes-money-amount\u0004{0} peso": [null, "{0} peso", "{0} pesos"],
  "andes-money-amount\u0004{0} peso argentino": [null, "{0} peso argentino", "{0} pesos argentinos"],
  "andes-money-amount\u0004{0} peso chileno": [null, "{0} peso chileno", "{0} pesos chilenos"],
  "andes-money-amount\u0004{0} peso colombiano": [null, "{0} peso colombiano", "{0} pesos colombianos"],
  "andes-money-amount\u0004{0} peso cubano convertible": [null, "{0} peso cubano conversível", "{0} pesos conversíveis cubanos"],
  "andes-money-amount\u0004{0} peso cubano": [null, "{0} peso cubano", "{0} pesos cubanos"],
  "andes-money-amount\u0004{0} peso dominicano": [null, "{0} peso dominicano", "{0} pesos dominicanos"],
  "andes-money-amount\u0004{0} peso mexicano": [null, "{0} peso mexicano", "{0} pesos mexicanos"],
  "andes-money-amount\u0004{0} peso uruguayo": [null, "{0} peso uruguaio", "{0} pesos uruguaios"],
  "andes-money-amount\u0004{0} boliviano": [null, "{0} boliviano", "{0} bolivianos"],
  "andes-money-amount\u0004{0} real": [null, "{0} real", "{0} reais"],
  "andes-money-amount\u0004{0} unidad de fomento": [null, "{0} unidade de promoção", "{0} unidades de promoção"],
  "andes-money-amount\u0004{0} colón": [null, "{0} colon", "{0} colones"],
  "andes-money-amount\u0004{0} euro": [null, "{0} euro", "{0} euros"],
  "andes-money-amount\u0004{0} quetzal guatemalteco": [null, "{0} quetzal guatemalteco", "{0} quetzais guatemaltecos"],
  "andes-money-amount\u0004{0} lempira": [null, "{0} lempira", "{0} lempiras"],
  "andes-money-amount\u0004{0} córdoba": [null, "{0} córdoba", "{0} córdobas"],
  "andes-money-amount\u0004{0} balboa": [null, "{0} balboa", "{0} balboas"],
  "andes-money-amount\u0004{0} sol": [null, "{0} sol", "{0} sóis"],
  "andes-money-amount\u0004{0} guaraní": [null, "{0} guarani", "{0} guaranis"],
  "andes-money-amount\u0004{0} dólar": [null, "{0} dólar", "{0} dólares"],
  "andes-money-amount\u0004{0} bolívar": [null, "{0} bolívar", "{0} bolívares"],
  "andes-money-amount\u0004 con {0} centavo": [null, " com {0} centavo", " com {0} centavos"],
  "andes-money-amount\u0004 con {0} céntimo": [null, " com {0} cêntimo", " com {0} cêntimos"],
  "andes-money-amount\u0004 con {0} centésimo": [null, " com {0} centésimo", " com {0} centésimos"],
  "andes-money-amount\u0004 por {0}": [null, "por {0}"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
var _BTCIcon, _ETHIcon, _USDPIcon;
const namespace$3 = 'andes-money-amount__logo';
const MoneyAmountLogo = _ref => {
  let {
    currencyId,
    amountSize
  } = _ref;
  const CRYPTO_CURRENCY_ICON_OPTIONS = {
    BTC: _BTCIcon || (_BTCIcon = /*#__PURE__*/_jsx__default["default"](BTCIcon__default["default"], {})),
    ETH: _ETHIcon || (_ETHIcon = /*#__PURE__*/_jsx__default["default"](ETHIcon__default["default"], {})),
    USDP: _USDPIcon || (_USDPIcon = /*#__PURE__*/_jsx__default["default"](USDPIcon__default["default"], {}))
  };
  return /*#__PURE__*/_jsx__default["default"]("div", {
    "aria-hidden": true,
    className: "".concat(namespace$3, " ").concat(namespace$3, "-").concat(amountSize)
  }, void 0, CRYPTO_CURRENCY_ICON_OPTIONS[String(currencyId)]);
};
MoneyAmountLogo.displayName = 'MoneyAmountLogo';
var MoneyAmountLogo$1 = MoneyAmountLogo;
var _VisuallyHidden, _span2;
const namespace$2 = 'andes-money-amount';
const MoneyAmount = /*#__PURE__*/function () {
  const MoneyAmount = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var _span;
    let {
      amount: _willdeprecate$amount,
      applyHideDecimals = false,
      centsType = 'comma',
      className,
      combo = false,
      compact = false,
      currencyId: currencyIdProp,
      maxDecimals,
      meta = false,
      previous = false,
      showCurrencySymbol = false,
      showCurrencyText = false,
      showLogo = false,
      size = 36,
      suffix,
      symbol: symbolProp,
      type: _willdeprecate$type,
      value,
      weight = 'regular'
    } = _ref;
    const computedAmount = React.useMemo(() => computeAmount$1({
      amount: _willdeprecate$amount,
      value,
      currencyId: currencyIdProp,
      symbol: symbolProp,
      maxDecimals,
      applyHideDecimals
    }), [_willdeprecate$amount, value, currencyIdProp, symbolProp, maxDecimals, applyHideDecimals]);
    const {
      symbol,
      currencyId,
      fraction,
      cents
    } = computedAmount;
    warning__default["default"](currencyId || symbol, WARNING_CURRENCYID_OR_SYMBOL);
    const Component = previous ? 's' : 'span';
    const absoluteFraction = isNegative$1(fraction) ? fraction === null || fraction === void 0 ? void 0 : fraction.slice(1) : fraction;
    const calculatedCentsType = centsType === 'superscript' && size < 12 ? 'comma' : centsType;
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const isCrypto = _willdeprecate$type === 'crypto' || includes__default["default"](Object.values(currencies.CRYPTO_CURRENCY_IDS), currencyId);
    const amountClassNames = classNames__default["default"](namespace$2, className, {
      ["".concat(namespace$2, "--previous")]: previous,
      ["".concat(namespace$2, "--cents-").concat(calculatedCentsType)]: calculatedCentsType,
      ["".concat(namespace$2, "--compact")]: compact,
      ["".concat(namespace$2, "--weight-semibold")]: weight === 'semibold'
    });
    const centsClassNames = classNames__default["default"]("".concat(namespace$2, "__cents"), {
      ["".concat(namespace$2, "__cents--superscript-").concat(size)]: calculatedCentsType === 'superscript'
    });
    const amountStyles = React.useMemo(() => ({
      fontSize: size
    }), [size]);
    const centsStyles = React.useMemo(() => {
      const centsMargins = compact ? CENTS_SUPERSCRIPT_COMPACT_MARGINS : CENTS_SUPERSCRIPT_MARGINS;
      if (calculatedCentsType === 'superscript') {
        return {
          fontSize: CENTS_SUPERSCRIPT_FONT_SIZES[Number(size)] || size / 2,
          marginTop: centsMargins[Number(size)]
        };
      }
      return {};
    }, [size, calculatedCentsType, compact]);
    const metaValues = React.useMemo(() => meta ? {
      main: {
        itemProp: 'offers',
        itemScope: true,
        itemType: 'http://schema.org/Offer'
      },
      currency: {
        itemProp: 'priceCurrency',
        content: currencyId
      }
    } : {}, [meta, currencyId]);
    const getAccesibleText = () => {
      let text = isCrypto ? getCryptoAccesibleAmount(computedAmount, centsType) : getAccesibleAmount(i18n, combo, previous, computedAmount);
      text += suffix ? " ".concat(suffix && i18n.pgettext(namespace$2, 'por {0}', suffix)) : '';
      return text;
    };
    const getCents = () => {
      if (!cents) return null;
      const decimalSeparator = DECIMAL_SEPARATOR_BY_CENTS_TYPE[calculatedCentsType];
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, decimalSeparator && /*#__PURE__*/_jsx__default["default"]("span", {
        "aria-hidden": true
      }, void 0, decimalSeparator), !decimalSeparator && (_VisuallyHidden || (_VisuallyHidden = /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {
        "aria-hidden": true
      }, void 0, DECIMAL_SEPARATOR_COMMA))), _span || (_span = /*#__PURE__*/_jsx__default["default"]("span", {
        className: centsClassNames,
        style: centsStyles,
        "aria-hidden": true
      }, void 0, cents)));
    };
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
      className: amountClassNames,
      style: amountStyles
    }, metaValues.main, {
      ref: ref,
      role: "img",
      "aria-label": getAccesibleText(),
      "aria-roledescription": i18n.pgettext(namespace$2, 'Monto')
    }), showLogo && /*#__PURE__*/_jsx__default["default"](MoneyAmountLogo$1, {
      currencyId: currencyId,
      amountSize: size
    }), meta && /*#__PURE__*/_jsx__default["default"]("meta", {
      itemProp: "price",
      content: formatAmount$1(computedAmount)
    }), isNegative$1(fraction) && (_span2 || (_span2 = /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(namespace$2, "__negative-symbol"),
      "aria-hidden": true
    }, void 0, "-"))), /*#__PURE__*/React__default["default"].createElement("span", _extends__default["default"]({
      className: "".concat(namespace$2, "__currency-symbol")
    }, metaValues.currency, {
      "aria-hidden": true
    }), getCurrencySymbolAndText$1(symbol, currencyId, isCrypto, showCurrencyText, showCurrencySymbol)), /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(namespace$2, "__fraction"),
      "aria-hidden": true
    }, void 0, absoluteFraction), getCents(), suffix && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace$2, "__suffix ").concat(namespace$2, "__suffix-").concat(size),
      "aria-hidden": true
    }, void 0, "/".concat(suffix)));
  });
  MoneyAmount.displayName = 'MoneyAmount';
  return MoneyAmount;
}();
const namespace$1 = 'andes-money-amount__discount';
const MoneyAmountDiscount = /*#__PURE__*/function () {
  const MoneyAmountDiscount = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      className,
      size = 18,
      value,
      icon
    } = _ref;
    const styles = React.useMemo(() => ({
      fontSize: size
    }), [size]);
    return /*#__PURE__*/React__default["default"].createElement("span", {
      className: classNames__default["default"](namespace$1, className),
      style: styles,
      ref: ref
    }, icon && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace$1, "-icon-").concat(size)
    }, void 0, icon), "".concat(value, "% OFF"));
  });
  MoneyAmountDiscount.displayName = 'MoneyAmountDiscount';
  return MoneyAmountDiscount;
}();
var MoneyAmountDiscount$1 = MoneyAmountDiscount;
const namespace = 'andes-money-amount-combo';
const MoneyAmountCombo = /*#__PURE__*/function () {
  const MoneyAmountCombo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      className,
      previousValue,
      currentValue,
      discount,
      size = 24,
      compact = false
    } = _ref;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classNames__default["default"](namespace, className),
      ref: ref
    }, previousValue && /*#__PURE__*/React__default["default"].createElement(MoneyAmount, _extends__default["default"]({
      compact: compact,
      size: COMBO_SIZES.previousValue[size]
    }, previousValue, {
      className: classNames__default["default"]("".concat(namespace, "__previous-value"), previousValue.className),
      previous: true,
      combo: true
    })), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__main-container")
    }, void 0, /*#__PURE__*/React__default["default"].createElement(MoneyAmount, _extends__default["default"]({
      compact: compact,
      size: COMBO_SIZES.currentValue[size]
    }, currentValue, {
      combo: true
    })), discount && /*#__PURE__*/React__default["default"].createElement(MoneyAmountDiscount$1, _extends__default["default"]({
      size: COMBO_SIZES.discount[size]
    }, discount))));
  });
  MoneyAmountCombo.displayName = 'MoneyAmountCombo';
  return MoneyAmountCombo;
}();
var MoneyAmountCombo$1 = MoneyAmountCombo;
exports.MoneyAmount = MoneyAmount;
exports.MoneyAmountCombo = MoneyAmountCombo$1;
exports.MoneyAmountDiscount = MoneyAmountDiscount$1;
exports["default"] = MoneyAmount;
